module.exports = __webpack_public_path__ + "images/file_icons_v2/c-4623330dd73da476260b80b3e124cd48.svg";